import { useId } from 'react';
import { Languages } from 'lucide-react';

import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';
import { SimpleSelect } from '@/components/form/inputs/SimpleSelect';

type LanguageSelectorProps = {
  className?: string;
};

export function LanguageSelector({ className }: LanguageSelectorProps) {
  const { language, setLanguage, availableLanguages, t } = useTranslation();
  const selectId = useId();

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <label htmlFor={selectId} className="eyebrow flex items-center gap-1.5">
        <Languages className="h-3 w-3" aria-hidden />
        {t('profile.preferences.languageLabel')}
      </label>
      <SimpleSelect
        id={selectId}
        value={language}
        onChange={(value) => value && setLanguage(value as typeof language)}
        options={availableLanguages}
      />
    </div>
  );
}
